// extracted by mini-css-extract-plugin
export default {"container":"DomainFormAbout_container__el2vT","error":"DomainFormAbout_error__OGvl1"};